"use client";

import { useState } from "react";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";

import styles from "./expandable-profile-description.module.css";

interface ExpandableProfileDescriptionProps {
  text: string;
  readMoreLabel: string;
  readLessLabel: string;
  characterLimit?: number;
}

export default function ExpandableProfileDescription({
  text,
  readMoreLabel,
  readLessLabel,
  characterLimit = 520,
}: ExpandableProfileDescriptionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text.trim()) return null;

  const isLongText = text.length > characterLimit;

  return (
    <div className={styles.descriptionBlock}>
      <div className={styles.descriptionFrame}>
        <p
          className={`${styles.profileDescription} ${
            !isExpanded && isLongText ? styles.profileDescriptionCollapsed : ""
          }`}
        >
          {text}
        </p>

        {!isExpanded && isLongText ? (
          <span className={styles.descriptionFade} aria-hidden="true" />
        ) : null}
      </div>

      {isLongText ? (
        <button
          type="button"
          className={styles.descriptionToggle}
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((current) => !current)}
        >
          <span>{isExpanded ? readLessLabel : readMoreLabel}</span>
          {isExpanded ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
        </button>
      ) : null}
    </div>
  );
}
